//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  input
} from '@angular/core';

import {
  FormGroup
} from '@angular/forms';

import { Transforms } from '@shared/helpers/transforms';

@Component({
    selector: 'text-input',
    templateUrl: './text-input.component.html',
    styleUrl: './text-input.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TextInputComponent  {

  public id = input.required<string>();
  public formGroup = input.required<FormGroup>();  
  public label = input.required<string>();
  public maxLength = input<number>();
  public focus = input(false, {
    transform: Transforms.toBoolean
  });
  
  public readonly = input(false, {
    transform: Transforms.toBoolean
  });

  public required = input(false, {
    transform: Transforms.toBoolean
  });

  constructor() {}
  
}
